export enum SearchSettingsFieldsTranslates {
  Type = 'Тип',
  Tail = 'Хвост',
  Color = 'Цвет',
  Breed = 'Порода',
}
